<template>
  <!-- eslint-disable vue/require-component-is -->
  <!-- header -->
  <div>
    <el-top-nav-menu-4
      :companyTitle="$t('basicLayout.title')"
      :logoIsShow="false"
      :dashboard="shopPage"
      :showInput="showInput"
      :Menu4Href="Menu4Href"
      ref="topNavMenu"
      :logo="LOGO"
      width="1180px"
      padding="0"
      :showHelp="false"
    >
      <div class="ldg" @click="goser">
        <span class="dpng">{{ $t("page.applyUsername.btn.msg10") }}</span>
        <div class="los">
          <img :src="leftgg" />
        </div>
      </div>
    </el-top-nav-menu-4>
    <!-- openStep -->
    <registerStep :check_page="check_page"></registerStep>
    <div>
      <!-- content -->
      <router-view />

      <el-dialog
        class="dialog-center"
        title="提示"
        :visible.sync="dialogVisible2"
        :show-close="false"
        width="300px"
        show-divider
        show-shadow
        custom-class="el-dialog--customize"
      >
        <span>网络请求超时，请稍后再试</span>
        <span slot="footer" style="text-align: center">
          <el-button
            size="mini"
            type="primary-font-mini"
            @click="closeModalTimeout"
            >确定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import registerStep from "../../components/registerStep";
import LOGO from "@/basa/assets/images/logoS.png";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      leftgg: require("@/basa/assets/images/llop.png"),
      shopPage: this.$addUrlPerFix(process.env.VUE_APP_SHOPPAGE_URL),
      Menu4Href: true,
      LOGO: LOGO,
      showInput: false,
      leaves: "",
      companyMessage: null,
      flag: false,
      last: {},
      local: {},
      tableData: [
        {
          fileName: "营业执照",
          fileDetails: "通过最新年检"
        },
        {
          fileName: "法定代表人身份证正反面",
          fileDetails: ""
        },
        {
          fileName: "法定代表人授权委托书",
          fileDetails: ""
        },
        {
          fileName: "纳税人证明材料",
          fileDetails: "未办理统一社会信用代码需上传"
        },
        {
          fileName: "税务登记证",
          fileDetails:
            "未办理统一社会信用代码需上传，含增值税一般纳税人红章页面，国税加地税"
        },
        {
          fileName: "组织机构代码证",
          fileDetails: "未办理统一社会信用代码需上传"
        }
      ],
      tableDataTwo: [
        {
          fileName: "质量认证证书",
          fileDetails: ""
        },
        {
          fileName: "特殊行业资质证书",
          fileDetails: ""
        },
        {
          fileName: "组织机构及营业网络相关文件",
          fileDetails: ""
        },
        {
          fileName: "公司资质及荣誉文件",
          fileDetails: ""
        },
        {
          fileName: "生产许可证",
          fileDetails: ""
        },
        {
          fileName: "经销代理资格证明",
          fileDetails: ""
        },
        {
          fileName: "财务报表",
          fileDetails: "上年度经审计的财务报表"
        },
        {
          fileName: "合作业绩证明文件",
          fileDetails: ""
        },
        {
          fileName: "职业健康安全认证证书",
          fileDetails: ""
        },
        {
          fileName: "环境管理体系认证证书",
          fileDetails: ""
        },
        {
          fileName: "安全生产许可证",
          fileDetails: ""
        },
        {
          fileName: "近三年财务状况",
          fileDetails: ""
        },
        {
          fileName: "经营许可证",
          fileDetails: ""
        },
        {
          fileName: "报关注册登记",
          fileDetails: "海关注册码"
        },
        {
          fileName: "人员资质情况",
          fileDetails: "人员履历以及执业（职业）资格证明"
        },
        {
          fileName: "自有设备情况",
          fileDetails: ""
        },
        {
          fileName: "原产地证明",
          fileDetails: ""
        },
        {
          fileName: "保廉承诺书",
          fileDetails: ""
        },
        {
          fileName: "其他文件",
          fileDetails: ""
        }
      ]
    };
  },
  components: {
    registerStep
  },
  created() {
    if (sessionStorage.getItem("SET_CHECK_PAGE")) {
      this.changeCheckPage(sessionStorage.getItem("SET_CHECK_PAGE"));
    }
  },
  computed: {
    dialogVisible2() {
      return this.$store.state.app.isShowDialogTimeout;
    },
    ...mapGetters(["check_page"])
  },
  mounted() {
    // console.log(Cookies.get('access_token'))
  },
  methods: {
    ...mapActions(["changeCheckPage"]),
    closeModalTimeout() {
      this.$store.commit("SET_IS_SHOW_DIALOG_TIMEOUT", false);
    },
    goser() {
      this.$router.push({
        path: "/regView/mobileValidate"
      });
    }
  },
  watch: {
    rightClickNum: {
      handler() {
        if (this.rightClickNum == 0) {
          this.leftDisabled = true;
        }
      },
      immediate: true
    },
    check_page: {
      handler() {
        window.sessionStorage.setItem("check_page", this.check_page);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-top-nav-menu4 .sub-menu-wrapper-wrapper {
  background-color: #ff142f;
}
.ldg {
  float: right;
  margin-top: 30px;
  cursor: pointer;
}

.dpng {
  font-size: 16px;
  color: #ffffff;
  line-height: 18px;
  float: left;
  margin-right: 10px;
}

.los img {
  width: 100%;
}

.los {
  width: 18px;
  height: 18px;
  float: left;
}

> html,
body {
  font-family: Arial;
  background-color: #f5f5f9;
  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased; /*让字体更润滑*/
  -moz-osx-font-smoothing: grayscale; /*让字体更润滑*/
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); /*禁止链接高亮*/
  -webkit-touch-callout: none; /*禁止链接长按弹出选项*/
  height: 100%;
}
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
input,
button {
  border: 0 none;
  border-radius: 0px;
  outline: none;
}
/* header */
.header {
  min-width: 1260px;
  height: 80px;
  background: rgba(255, 20, 47, 1);
  position: relative;
}
.headerLogo {
  width: 115px;
  height: 40px;
  position: absolute;
  top: 20px;
  left: 50px;
}
.headerLine {
  display: block;
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 1px;
  position: absolute;
  top: 32px;
  left: 171px;
}
.header .headerTxt {
  width: 128px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  position: absolute;
  top: 29px;
  left: 178px;
}

/* content */
.sign-content {
  width: 1180px;
  height: 450px;
  background: #ffffff;
  margin: 20px auto;
  overflow: hidden;
  .one {
    margin-top: 20px;
    margin-left: 90px;
  }
  .two {
    margin-top: 20px;
    margin-left: 90px;
  }
  .three {
    margin-top: 45px;
    margin-left: 90px;
  }
  .four {
    margin-top: 42px;
    margin-left: 90px;
  }
  .five {
    margin-top: 44px;
    margin-left: 90px;
  }
}
.register1 {
  font-family: PingFangSC-Regular;
  font-size: 20px;
  color: #4a4a4a;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 400;
  margin: 19px 0px 0px 70px;
}
.title {
  height: 25px;
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #4a4a4a;
  font-weight: 600;
}
.title p {
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #4a4a4a;
  font-weight: 400;
  margin-top: 6px;
  margin-left: 22px;
}

.right-btn {
  // position: absolute;
  // bottom: 20px;
  // left: 340px;
  position: relative;
  left: calc(50% - 250px);
  margin-bottom: 20px;
  width: 500px;
  height: 40px;
  background: rgba(255, 20, 47, 1);
  border-color: #ff142f;
  border-radius: 4px;
  span {
    span {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFangSC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
    }
  }
}
.right-btn:hover {
  background: rgba(255, 20, 47, 1);
  border-color: #ff142f;
}
</style>
